import React, { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';

export const HistoryRouter = ({ history, children }) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => {
    const unlisten = history.listen((update) => {
      if (update.location) {
        setState(update);
      } else {
        setState({ action: history.action, location: history.location });
      }
    });

    return unlisten;
  }, [history]);

  return (
    <Router
      navigationType={state.action}
      location={state.location}
      navigator={history}
    >
      {children}
    </Router>
  );
};
